import * as API from '@/api';

export const favourite = {
  state: {
    favouriteResult: { artworks: [], temples: [], themes: [], albums: [] }
  },
  getters: {
    favouriteResult(state) {
      return state.favouriteResult;
    }
  },
  mutations: {
    setFavouriteResult(state, payload) {
      return state.favouriteResult = payload
    }
  },
  actions: {
    async addFavorite(_, article) {
      await API.POST_TOKEN('/favourites', article)
    },
    async getFavouriteResult({ commit }) {
      const favouriteResult = await API.GET_TOKEN('/favourites')
      commit('setFavouriteResult', favouriteResult.data);
    },
    async deleteFavourite({dispatch}, favouriteId) {
      try {
        await API.DELETE(`/favourites/${favouriteId}`)
        dispatch('getFavouriteResult')
      } catch(err) {
        console.log(err)
      }
    }
  }
};
